export const getNameWithoutExt = (fileName) => {
  const dotIndex = fileName.lastIndexOf('.');
  return dotIndex !== -1 ? fileName.slice(0, dotIndex) : fileName;
};
